import React from "react";
import classNames from "classnames";

interface SectionTitleProps {
  children: React.ReactNode;
  className?: string;
}

export default function SectionTitle({
  children,
  className,
}: SectionTitleProps) {
  return (
    <div
      className={classNames(
        className,
        "text-lg font-medium text-gray-600 flex flex-col uppercase"
      )}
    >
      {children}
    </div>
  );
}
